export const SIDEBAR_WIDTH = 268 as const;
export const SIDEBAR_COLLAPSED_WIDTH = 72 as const;
export const NAVIGATION_BAR_HEIGHT = 68 as const;
export const AUTHENTICATION_CONTAINER_MAX_WIDTH = 720 as const;

export const MENU_ITEM_HEIGHT = 40 as const;
export const MENU_MAX_HEIGHT = MENU_ITEM_HEIGHT * 6;

export const DEFAULT_MENU_WIDTH = 300;
export const DEFAULT_MENU_TOP_OFFSET = 10;
export const DEFAULT_MENU_LEFT_OFFSET = 8;

export const SMALL_PROJECT_MODAL_WIDTH = 500;
export const DEFAULT_PROJECT_MODAL_WIDTH = 620;
export const MEDIUM_PROJECT_MODAL_WIDTH = 700;
export const LARGE_PROJECT_MODAL_WIDTH = 860;

export const DEFAULT_PICKER_WIDTH = 150;
export const LARGE_PICKER_WIDTH = 200;
export const LARGER_PICKER_WIDTH = 250;

export const SMALLER_BUTTON_WIDTH = 75;
export const SMALL_BUTTON_WIDTH = 125;
export const DEFAULT_BUTTON_WIDTH = 150;
export const LARGE_BUTTON_WIDTH = 225;
export const HEADER_BUTTON_HEIGHT = 42;
